import { Card } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { FunctionComponent } from 'react';
import './DetailsCard.scss';

interface IDetailsCardProps {
  title?: string;
  className?: string | object;
}

const DetailsCard: FunctionComponent<IDetailsCardProps> = (props) => {
  const { title, className, children } = props;

  const classes = classNames('details-card', className);

  return (
    <div className={classes}>
      {title && <h3 className="pb-3">{title}</h3>}
      <Card type="stroke">{children}</Card>
    </div>
  );
};

export default DetailsCard;
